<template>
  <ModalSlotted @close="$emit('close')">
    <div class="modal-kim" slot="body">
      <div>
        <slot name="body" />
      </div>
      <Kim
        :mood="mood"
        :color="color"
        :style="position === 'left' ? 'order: -1' : ''"
      />
    </div>
  </ModalSlotted>
</template>

<script lang="ts">
export default {
  name: 'ModalKim',
  props: {
    mood: {
      type: String,
      default: 'neutral'
    },
    color: {
      type: String,
      default: '#B9008D'
    },
    position: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-kim {
  display: flex;
  justify-content: space-between;
  width: 100vw;
  @media ($screen-lg) {
    width: auto;
  }
  >div {
    padding: 2rem 3rem;
    width: calc(100% - 3rem);
    @media ($screen-md) {
      display: block;;
      width: 55%;
    }
  }
  >figure {
    width: 45%;
    display: none;
    @media ($screen-md) {
      display: block;;
    }
  }
}
</style>
